<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (selectedCurrent = e)"
          :label="'Cari'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          filled
          solo
          dense
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
          clearable
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')
                    "
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport"><v-icon left>mdi-filter</v-icon>FİLTRELE</v-btn>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import { required } from "vuelidate/lib/validators";
import { validationMessages } from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "ZiyaretRaporu",
  components: {SearchSelect},
  props:{
    reportType:{
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.fetchSalesPersonList({
      params:{},
      body:{}
    });
  },
  computed:{
    ...mapState("auth",["user"]),
    ...mapState("current",["salesPersonList"]),
    ...mapState("order", ["B2BOrders","B2BOrdersHeaders","B2BOrdersLoading","B2BOrdersMetaData","orderInvoiceControlLoading"]),
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      selectedCurrent: null,
      salesPersonCode: null,
      searchText: null,
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  methods:{
    ...mapActions("current", ["fetchSalesPersonList","fetchCurrentList"]),
    ...mapActions("order", ["invoiceControlOrder"]),
    formattedDate,
    validationMessages,
    filterReport(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          EndDate: this.dateRangeEnd,
          CurrentCode: this.selectedCurrent,
          SalesPersonCode: this.salesPersonCode,
        };
        this.$emit("reportFilterChange",this.filterRequestObject);
      }
      else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
    async _fetchCurrentList(){
      this.currentSearchResult = await this.fetchCurrentList({
        params:{
          userId : this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(this.currentSearchText == "" || this.currentSearchText == null  ? false : true) && {searchText: this.currentSearchText }
        },
        body: {

        },
        loading: false
      });
      this.currentSearchLoading = false;
    },
  },
  watch:{
    currentSearchText:function(newVal){
      if(newVal && (newVal.length > 2))
      {
        if(this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();
        },1500);
      }
      else
      {
        this.searchCurrentLoading = false;
        if(this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
      }
    },
    perPage: function (newVal) {
      newVal;
      this.currentPage = 1;
    },

    currentPage: function (newVal) {
      newVal;
    }
  }
}
</script>

<style scoped>

</style>